var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandLayerLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.943,16.846l-11.943,7.166L.057,16.846l5.664-3.398,1.478,1.445-3.255,1.953,8.057,4.834,8.057-4.834-3.256-1.953,1.478-1.445,5.665,3.399ZM7.058,11.958c-2.736-2.737-2.736-7.178-.008-9.907,1.322-1.322,3.081-2.05,4.95-2.05s3.628.728,4.949,2.05c1.322,1.322,2.051,3.08,2.051,4.95s-.729,3.627-2.051,4.95l-4.949,4.841-4.942-4.833Zm1.406-1.422l3.536,3.458,3.543-3.466c.937-.937,1.457-2.192,1.457-3.528s-.521-2.591-1.465-3.536-2.199-1.464-3.535-1.464-2.592.52-3.536,1.464c-1.949,1.95-1.949,5.122,0,7.071Zm3.536-.545c1.657,0,3-1.343,3-3s-1.343-3-3-3-3,1.343-3,3,1.343,3,3,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandLayerLocation);
export default __webpack_public_path__ + "static/media/land-layer-location.39a3073c2cb34515e5fc27fa753b80e8.svg";
export { ForwardRef as ReactComponent };